// Angular
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'kt-alert-entity-dialog',
	templateUrl: './alert-entity-dialog.component.html'
})
export class AlertEntityDialogComponent {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<AlertEntityDialogComponent>,
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<AlertEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			title: string,
			description: string
		}
	) {}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}
}
